import React, { createContext, useContext, useState, useEffect } from 'react';

const WorkflowContext = createContext();

export const useWorkflow = () => useContext(WorkflowContext);

export const WorkflowProvider = ({ children }) => {
  const [phase, setPhase] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [location, setLocation] = useState('');
  const [markdownReport, setMarkdownReport] = useState('');
  const [error, setError] = useState('');
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [history, setHistory] = useState([]);

  // Theme
  const [isDark, setIsDark] = useState(localStorage.getItem('CS_THEME') !== 'light');

  // Active Connection
  const [provider, setProvider] = useState(localStorage.getItem('CS_PROVIDER') || 'straico');
  const [apiKey, setApiKey] = useState(localStorage.getItem('CS_API_KEY') || '');
  const [selectedModel, setSelectedModel] = useState(localStorage.getItem('CS_MODEL') || '');

  // Provider Keys
  const [openRouterKey, setOpenRouterKey] = useState(localStorage.getItem('CS_OPENROUTER_KEY') || '');
  const [openaiKey, setOpenaiKey] = useState(localStorage.getItem('CS_OPENAI_KEY') || '');
  const [anthropicKey, setAnthropicKey] = useState(localStorage.getItem('CS_ANTHROPIC_KEY') || '');
  const [geminiKey, setGeminiKey] = useState(localStorage.getItem('CS_GEMINI_KEY') || '');
  const [deepseekKey, setDeepseekKey] = useState(localStorage.getItem('CS_DEEPSEEK_KEY') || '');
  const [qwenKey, setQwenKey] = useState(localStorage.getItem('CS_QWEN_KEY') || '');

  const [reportLayout, setReportLayout] = useState(localStorage.getItem('CS_REPORT_LAYOUT') || 'long');

  useEffect(() => {
    localStorage.setItem('CS_THEME', isDark ? 'dark' : 'light');
    document.documentElement.classList.toggle('light', !isDark);
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem('CS_PROVIDER', provider);
    localStorage.setItem('CS_API_KEY', apiKey);
    localStorage.setItem('CS_MODEL', selectedModel);
    localStorage.setItem('CS_OPENROUTER_KEY', openRouterKey);
    localStorage.setItem('CS_OPENAI_KEY', openaiKey);
    localStorage.setItem('CS_ANTHROPIC_KEY', anthropicKey);
    localStorage.setItem('CS_GEMINI_KEY', geminiKey);
    localStorage.setItem('CS_DEEPSEEK_KEY', deepseekKey);
    localStorage.setItem('CS_QWEN_KEY', qwenKey);
  }, [provider, apiKey, selectedModel, openRouterKey, openaiKey, anthropicKey, geminiKey, deepseekKey, qwenKey]);

  const resetWorkflow = () => {
    setPhase(0);
    setCompanyName('');
    setLocation('');
    setMarkdownReport('');
    setError('');
    setSelectedEntity(null);
  };

  return (
    <WorkflowContext.Provider
      value={{
        phase, setPhase,
        companyName, setCompanyName,
        location, setLocation,
        markdownReport, setMarkdownReport,
        error, setError,
        selectedEntity, setSelectedEntity,
        history, setHistory,
        isDark, setIsDark,
        provider, setProvider,
        apiKey, setApiKey,
        selectedModel, setSelectedModel,
        openRouterKey, setOpenRouterKey,
        openaiKey, setOpenaiKey,
        anthropicKey, setAnthropicKey,
        geminiKey, setGeminiKey,
        deepseekKey, setDeepseekKey,
        qwenKey, setQwenKey,
        reportLayout, setReportLayout,
        resetWorkflow,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};